/* eslint-disable arrow-body-style */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { RecentLinkData, RecentPostsWrapper, RecentPostsHeading, RecentPostsLink } from './styles'
import { cleanPathname } from '../common/urlValidation'

const RecentItemPosts = props => {
  const { title, itemId, posts } = props

  return (
    <RecentPostsWrapper id="recentItemsPosts">
      <RecentPostsHeading>{title || 'Recent Posts'} </RecentPostsHeading>
      {posts?.map((post, index) => {
        const oneItem = post?.attributes

        return (
          <a href={itemId === 'articles' ? cleanPathname(oneItem?.url) : cleanPathname(`/${itemId}/${oneItem?.slug}/`)}>
            <RecentPostsLink key={index}>
              <RecentLinkData>{oneItem?.title || oneItem?.articleTitle}</RecentLinkData>
            </RecentPostsLink>
          </a>
        )
      })}
    </RecentPostsWrapper>
  )
}

export default RecentItemPosts
